// extracted by mini-css-extract-plugin
export default {"scroll_button":"scrollbutton_scroll_button__RijtO"};